<form [formGroup]='formDetails' (ngSubmit)="agregarProducto()" novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">
        <h4>
          Agregar productos
        </h4>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col dato">
            <div class="md-form">
              <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                formControlName="codigoProducto" />
              <label for="codProduct">Código de producto</label>
              <div *ngIf="
              formDetails.get('codigoProducto').invalid &&
              (formDetails.get('codigoProducto').dirty ||
              formDetails.get('codigoProducto').touched)
            ">
                <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('required')">
                  Ingrese código de producto
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarProducto()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
              {{ productoSeleccionado.descripcion}}
            </h6>
          </div>
          <div class="col dato">
            <div class="md-form">
              <mdb-select [options]="optionsFormato" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
              <label>Formato</label>
              <div *ngIf="
                    formDetails.get('formato').invalid &&
                    (formDetails.get('formato').dirty ||
                    formDetails.get('formato').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('formato').hasError('required')">
                  Ingrese formato
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col dato">
            <div class="md-form">
              <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                monto formControlName="cantidad" />
              <label for="cant">Cantidad</label>
              <div *ngIf="
                    formDetails.get('cantidad').invalid &&
                    (formDetails.get('cantidad').dirty ||
                    formDetails.get('cantidad').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('cantidad').hasError('required')">
                  Ingrese cantidad
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('cantidad').hasError('min')">
                  Cantidad debe ser mayor a 0
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col dato">
            <Strong class="title">Precio unitario</Strong>
            <span class="value monto">$ 0.000</span>
          </div>
        </div>

        <div class="row">
          <div class="col" style="max-width: 150px; display: flex; align-items: center;">
            <h5>Descuento</h5>
          </div>
          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <input value="" type="text" id="descuentoPorcent" class="form-control" placeholder="%" required
                #descuentoPorcent monto formControlName="procentajeDescuento" />
              <label for="descuentoPorcent">Porcentaje %</label>
              <div *ngIf="
                    formDetails.get('procentajeDescuento').invalid &&
                    (formDetails.get('procentajeDescuento').dirty ||
                    formDetails.get('procentajeDescuento').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('procentajeDescuento').hasError('required')">
                  Ingrese procentaje
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('procentajeDescuento').hasError('min')">
                  Porcentaje descuento debe ser mayor a 0
                </mdb-error>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect>
        Agregar producto
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">
                  <mdb-checkbox></mdb-checkbox>
                </th>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Medida</th>
                <th scope="col">Precio $</th>
                <th scope="col">Desc. %</th>
                <th scope="col">Total $</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <mdb-checkbox></mdb-checkbox>
                </td>
                <td>01064622</td>
                <td>Cassata Savory Vainilla 1 Lt.</td>
                <td>5</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect>
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <mdb-checkbox></mdb-checkbox>
                </td>
                <td>01064622</td>
                <td>Cassata Savory Vainilla 1 Lt.</td>
                <td>5</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect>
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <mdb-checkbox></mdb-checkbox>
                </td>
                <td>01064622</td>
                <td>Cassata Savory Vainilla 1 Lt.</td>
                <td>5</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect>
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">impto. Adic.</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td>$ 40.000</td>
                <td><strong>$ 40.000</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row">
      {{formDetails.value | json}}
    </div>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>
